import React from 'react';
import '../lib/dotlottieWasm';
import { DotLottieReact as DotLottieReactRaw, DotLottieReactProps } from '@lottiefiles/dotlottie-react';
import successLottie from '../assets/success.lottie';

const DotLottieReact = DotLottieReactRaw as unknown as React.FC<DotLottieReactProps>;

interface SuccessAnimationProps {
  size?: number;
  loop?: boolean;
  className?: string;
}

const SuccessAnimation: React.FC<SuccessAnimationProps> = ({
  size = 96,
  loop = false,
  className,
}) => {
  return (
    <div className={className} style={{ width: size, height: size }}>
      <DotLottieReact src={successLottie} loop={loop} autoplay />
    </div>
  );
};

export default SuccessAnimation;
